import React, { useState, useEffect } from "react";
import axios from "axios";
import NavbarComponent from "./NavbarComponent";
import Footer from "./Footer";
import API_URLS from "./apiConfig";

const ContactUs = () => {
  const [metadata, setMetadata] = useState(null); // State to hold the fetched metadata
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [flashMessage, setFlashMessage] = useState(null);
  const imageUrl=API_URLS.baseUrl+'page_images/013.jpeg';

  useEffect(() => {
    // Fetch metadata on component mount
    const fetchMetadata = async () => {
      try {
        const response = await axios.get(API_URLS.getContact);
        setMetadata(response.data);
        // Initialize formData with empty values
        const initialFormData = Object.keys(response.data.contact_form).reduce((acc, field) => {
          acc[field] = "";
          return acc;
        }, {});
        setFormData(initialFormData);
      } catch (error) {
        console.error("Error fetching metadata:", error);
      }
    };

    fetchMetadata();
  }, []);

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      [id]: "", // Clear error on change
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (metadata?.contact_form) {
      Object.keys(metadata.contact_form).forEach((field) => {
        const validations = metadata.contact_form[field].validation || [];
        const value = formData[field]?.trim();
        validations.forEach((rule) => {
          if (rule.key === "required" && !value) {
            newErrors[field] = rule.value || `${field} is required`;
          }
        });
      });
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      const response = await axios.post(API_URLS.postContact, formData);// Replace with actual submission API
      console.log("Response:", response.data);
      setFlashMessage({ message: "Form submitted successfully!", type: "success" });
      // Reset form after submission
      const resetFormData = Object.keys(formData).reduce((acc, key) => {
        acc[key] = "";
        return acc;
      }, {});
      setFormData(resetFormData);
    } catch (error) {
      console.error("Error submitting the form:", error);
      setFlashMessage({ message: "An error occurred. Please try again.", type: "error" });
    }
  };

  if (!metadata) return <p>Loading...</p>;

  return (
    <>
      <NavbarComponent />
      <div className="contact-container">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <h1 className="contact-header">{metadata.title || "Contact Us"}</h1>
              <div
                className="contact-text"
                dangerouslySetInnerHTML={{ __html: metadata.content }}
              ></div>

              {flashMessage && (
                <div
                  className={`flash-message ${flashMessage.type === "success" ? "success" : "error"}`}
                >
                  {flashMessage.message}
                </div>
              )}

              <form className="contact-form" onSubmit={handleSubmit}>
                {Object.keys(metadata.contact_form).map((field) => {
                  const fieldData = metadata.contact_form[field];
                  return (
                    <div className="form-group" key={field}>
                      <label htmlFor={field} className="form-label">
                        {fieldData.label_text}
                      </label>
                      <input
                        id={field}
                        type={field === "message" ? "textarea" : "text"}
                        className="form-input"
                        placeholder={fieldData.placeholder}
                        value={formData[field]}
                        onChange={handleInputChange}
                      />
                      {errors[field] && <span className="error-text">{errors[field]}</span>}
                    </div>
                  );
                })}
                {/* <button type="submit" className="viewmore-btn">
                  Submit
                </button> */}
                <button type="submit" className="viewmore-btn">
                  Submit
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="42"
                    height="42"
                    viewBox="0 0 48 48"
                    fill="none"
                  >
                    <rect width="42" height="42" fill="none" />
                    <path
                      d="M16 32L32 16M32 16H20M32 16V28"
                      stroke="#fff"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </form>
            </div>
            <div className="col-md-6 contact-img-outer">
            <img
                src={imageUrl}
                alt="Contact"
              />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ContactUs;
